export function SuccessUnsubscribe() {
    return (
        <div style={{ height: "60vh" }}>
            <div style={{ height: "100%", position: "relative", display: "flex", flexDirection: "column", alignItems: "center", marginTop: "22vh", gap: "3vh" }}>
                <h1 style={{ textAlign: "center"}}>Vous vous êtes bien désinscrit!</h1>
                <div style={{ width: "80%", textAlign: "center" }}>Votre désinscription devrait être effective pour la prochaine Newsletter.</div>
            </div>
        </div>
    )
}